import { CouncilDashboardPage, DashboardMetrics } from '@/pages/council/dashboard';
import { createFileRoute } from '@tanstack/react-router';

type DashboardSearch = {
	view?: string;
	startDate?: string;
	endDate?: string;
	material?: string;
	suburb?: string;
	postcode?: string;
	selectedMetric?: DashboardMetrics;
};

export const Route = createFileRoute('/council/$councilId/dashboard')({
	component: CouncilDashboardPage,
	validateSearch: (search): DashboardSearch => {
		return {
			view: search.view?.toString(),
			startDate: search.startDate?.toString(),
			endDate: search.endDate?.toString(),
			material: search.material?.toString(),
			suburb: search.suburb?.toString(),
			postcode: search.postcode?.toString(),
			selectedMetric: search.selectedMetric?.toString() as DashboardMetrics | undefined,
		};
	},
});
